import React from "react";
import { createPortal } from "react-dom";
import { 
  IconBolt, 
  IconX,
  IconDatabase,
  IconBrain,
  IconPlugConnected,
  IconMessageCircle
} from "@tabler/icons-react";
import { FormattedMessage } from "react-intl";

import styles from "./styles.module.css";

interface AgentInfoModalProps {
  onClose: () => void;
}

export default function AgentInfoModal({ onClose }: AgentInfoModalProps) {
  // Using createPortal to render the modal at the root level of the DOM
  return createPortal(
    <div className={styles.overlayContainer} onClick={onClose}>
      <div className={styles.modalCard} onClick={(e) => e.stopPropagation()}>
        
        <button className={styles.closeButton} onClick={onClose}>
          <IconX size={20} />
        </button>

        <div className={styles.heroSection}>
          <div className={styles.avatarWrapper}>
            <IconBolt size={48} stroke={1.5} />
            <div className={styles.pulseRing}></div>
          </div>
          <h2 className={styles.agentName}>
            <FormattedMessage id="ai.agent.title" />
          </h2>
        </div>

        <div className={styles.contentSection}>
          <p className={styles.description}>
            <FormattedMessage id="ai.agent.description" />
          </p>
          
          <ul className={styles.featureList}>
            <li>
              <div className={styles.iconBox}><IconDatabase size={18}/></div>
              <span>
                <FormattedMessage id="ai.agent.feature.knowledge" />
              </span>
            </li>

            <li>
              <div className={styles.iconBox} style={{ width: "40px" }}><IconBrain size={18}/></div>
              <span>
                <FormattedMessage id="ai.agent.feature.behavior" />
              </span>
            </li>

            <li>
              <div className={styles.iconBox}><IconPlugConnected size={18}/></div>
              <span>
                <FormattedMessage id="ai.agent.feature.integrations" />
              </span>
            </li>

            <li>
              <div className={styles.iconBox}><IconMessageCircle size={18}/></div>
              <span>
                <FormattedMessage id="ai.agent.feature.channels" />
              </span>
            </li>
          </ul>
        </div>

      </div>
    </div>,
    document.body
  );
}
